import React from 'react';

const ParkingImage = ({ price, duration }) => {
  return (
    <div className="bg-parking w-[100px] h-[100px] py-2 px-3 text-white leading-3 overflow-hidden shrink-0 rounded-md">
      <span className="block text-2xl icon icon-parking"></span>
      <span className="block text-2xl font-bold">&euro; {price}</span>
      <span className="text-xs">{duration}</span>
    </div>
  );
};

export default ParkingImage;
